import { NavLink } from "react-router-dom";

import classes from './MainNavigation.module.css';

function MainNavigation() {
    return(
        <div className={classes.header}>
            <nav>
                <ul className={classes.links}>
                    <li>
                        <NavLink to="/availability" className={({ isActive}) => isActive ? classes.active : undefined } end
                        >
                            Availability
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/lineup" className={({ isActive }) => isActive ? classes.active: undefined }
                        >
                            Lineup 
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/lineupadmin" className={({ isActive }) => isActive ? classes.active: undefined }
                        >
                            Admin 
                        </NavLink>
                    </li>
                </ul>
            </nav>
        </div>
    );
}

export default MainNavigation;